import PropTypes from "prop-types";
import { m } from "framer-motion";
// @mui
import { Container, Typography } from "@mui/material";
// components
import { MotionContainer, varBounce } from "../components/animate";
// assets
import { ForbiddenIllustration } from "../assets/illustrations";
//
import { useAuthContext } from "../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../routes/paths";
import { useLocales } from "src/locales";

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  children: PropTypes.node,
  hasContent: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.string),
};

export default function RoleBasedGuard({ hasContent, roles, children }) {
  // Logic here to get current user role
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { translate } = useLocales();

  const currentRole = user?.role;

  if  (typeof roles !== "undefined" && !roles.includes(currentRole) && roles.includes("nightzAccount") && user?.approval === "NIGHTZ_ACCOUNT") {
    return <> {children} </>;
  }

  if (typeof roles !== "undefined" && !roles.includes(currentRole)) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: "center", mt: 12 }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            {translate("guards.permissionDenied.title")}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: "text.secondary" }}>
            {translate("guards.permissionDenied.body")}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : (
      navigate(PATHS.listings.list)
    );
  }

  return <> {children} </>;
}
